<template>
  <div id="mb-editor-page">
    <div class="editor-container">
      <div style="width: 100%; height: 100%; position: relative">
        <div class="icon-container" @mouseenter="exitHover = true" @mouseleave="exitHover = false">
          <img draggable="false" class="controll-icon" @click="closeInfo()" :src="exitIcon" />
          <transition name="icon-fade">
            <img draggable="false" v-if="exitHover" class="controll-icon" @click="closeInfo()" :src="exitIconOn" />
          </transition>
        </div>
        <div class="text-container">
          <div :key="'text-container-element-' + index" v-for="(element, index) in filteredData">
            <div class="flex-container">
              <p class="title" v-html="element.text"></p>
              <!-- <input v-if="" /> -->
              <div style="width: 20%" v-if="element.search">
                <b-form-input
                  @input="itemsFileter()"
                  type="text"
                  v-model="findMe"
                  placeholder="Wpisz ID"
                  style="z-index: 5"
                ></b-form-input>
              </div>
            </div>
            <p :key="'text-container-element-text-' + indexIt" v-for="(it, indexIt) in element.items" class="text">
              <span class="bold color-044a9d" v-if="it.id" v-html="it.id"></span>
              <br v-if="it.id" />
              <span v-html="it.text"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import INFO from '../../config/info/tablice.js';
export default {
  name: 'mb-editor-page',
  components: {},
  data: function () {
    return {
      findMe: '',
      allData: [],
      filteredData: [],
      exitHover: false,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  beforeMount() {
    this.init();
  },
  methods: {
    itemsFileter() {
      if (this.findMe == '') {
        this.filteredData = this.allData;
      } else {
        let tmpData = [];
        this.allData.forEach((element) => {
          if (element.search) {
            let tmpElement = {
              text: element.text,
              search: true,
              items: [],
            };
            element.items.forEach((it) => {
              if (it.id.includes(this.findMe)) {
                tmpElement.items.push(it);
              }
            });
            tmpData.push(tmpElement);
          } else {
            tmpData.push(element);
          }
        });
        this.filteredData = tmpData;
      }
    },
    init() {
      try {
        this.allData = require('__mainSrcDir/config/gridViewConfigs/editorPage/editorPage.conf.js').default;
        this.filteredData = this.allData;
      } catch {
        console.log(
          '%cEditorPageConfig - error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
    },
    closeInfo() {
      this.$emit('closeInfo');
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    color() {
      return this.$store.getters.getMainColor;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },

    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cExitIcon MbEditorPage- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cExitIconOn MbEditorPage- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
#mb-editor-page
  width: 100vw
  height: 100vh
  overflow: hidden
  z-index: 5
  background: rgba(0,0,0, .3)
  position: absolute
  top: 0
  left: 0
  font-family: $gameFontFamily
  .editor-container
    position: absolute
    right: 30px
    width: 78vmax
    height: 79vmin
    bottom: 4vmin
    background: white
    // overflow-y: scroll
    border-radius: 10px
    box-shadow: 0px 0px 10px rgba(0,0,0, 0.2)
    padding: 20px
    .flex-container
      display: flex
      align-items: center
      justify-content: flex-start
    .text-container
      width: 100%
      position: absolute
      top: 40px
      height: calc(100% - 80px)
      overflow-y: scroll
      input
        margin: 10px
      p
        padding: 0
        margin: 0
      .bold
        font-weight: bold
      .color-044a9d
        color: #044a9d
      .title
        margin-top: 10px
        margin-bottom: 10px
        font-weight: bold
        font-size: 24px
      .text
        margin-bottom: 10px
        // font-weight: bold
        font-size: 18px
    .icon-container
      top: 10px
      right: 5.5px
      position: absolute
      .controll-icon
        width: 32px
        height: 32px
        top: -10px
        right: -9px
        position: absolute
        transition: .5s
        // transform: scale(.9)
        cursor: pointer
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
.text-container::-webkit-scrollbar-track
  -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2)
  background-color: white

.text-container::-webkit-scrollbar
  // border-radius: 0 10px 10px 0
  width: 20px
  background-color: white

.text-container::-webkit-scrollbar-thumb
  // border-radius: 0 10px 10px 0
  background-color: #044a9d
  border: 2px solid #044a9d

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
</style>
